<template>
  <div>
    <vx-card>
      <div>
        <div class="flex justify-between items-center">
          <p style="font-size: 18px; font-weight: 700">시설 등록</p>
          <div class="flex justify-end">
            <vs-button v-if="isAdmin && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
            <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
            <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
          </div>
        </div>
        <p class="title mt-5 mb-5">시설 정보</p>
        <div class="writeGridContainer">
          <div>
            <div>시설명</div>
            <ml-input v-model="form.field_name" />
          </div>
          <div>
            <div>관리감독자</div>
            <ml-input v-model="form.manager_name" />
          </div>
          <div></div>

          <div>
            <div>준공일</div>
            <date-selector class="popup-fixed" v-model="form.be_completed_at"></date-selector>
          </div>
          <div>
            <div>사업금액(원)</div>
            <comma-input v-model="form.deposit_amount" />
          </div>
          <div>
            <div>시설 위치(주소)</div>
            <ml-input v-model="form.address" />
          </div>

          <div>
            <div>구분</div>
            <vs-select class="w-full" autocomplete v-model="cat1" :disabled="cat1List.length === 0" @change="onChangeCat1">
              <vs-select-item v-for="option in cat1List" :key="option" :text="option" :value="option" />
            </vs-select>
          </div>
          <div>
            <div>종류</div>
            <vs-select class="w-full" autocomplete v-model="cat2" :disabled="cat2List.length === 0" @change="onChangeCat2">
              <vs-select-item v-for="option in cat2List" :key="option" :text="option" :value="option" />
            </vs-select>
          </div>
          <div>
            <div>세분류</div>
            <vs-select class="w-full" autocomplete v-model="cat3" :disabled="cat3List.length === 0" @change="onChangeCat3">
              <vs-select-item v-for="option in cat3List" :key="option" :text="option" :value="option" />
            </vs-select>
          </div>

          <div>
            <div>종별</div>
            <vs-select class="w-full" autocomplete v-model="newcat4" :disabled="cat4List.length === 0 || (cat4List.length === 1 && !cat4List[0].classification)" @change="onChangeCat4">
              <vs-select-item v-for="option in ['1종', '2종', '3종', '법정외']" :key="option" :text="option" :value="option" />
            </vs-select>
          </div>
          <div>
            <div>안전 등급</div>
            <ml-input v-model="form.safety_grade" />
          </div>
          <div>
            <div>관리형태</div>
            <ml-input v-model="form.format" />
          </div>

          <div>
            <div>규모1</div>
            <ml-input v-model="form.scale1" />
          </div>
          <div>
            <div>규모2</div>
            <ml-input v-model="form.scale2" />
          </div>
          <div>
            <div>규모3</div>
            <ml-input v-model="form.scale3" />
          </div>
        </div>
      </div>

      <!-- 담당 부서 및 수급업체 현황 -->
      <company-add-module v-model="companyList" @remove="removeCompany" />

      <!-- 참여 인원 정보 -->
      <!-- <company-user-auth-module
        :colData="[
          { head: '구분', key: 'company_id' },
          { head: '사용자명', key: 'name' },
          { head: '연락처', key: 'phone' },
        ]"
        :users="userList"
        v-model="joinUsers"
      /> -->

      <div class="my-8" style="display: grid; grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div>
          <p class="title-n">현장조감도</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />
        </div>
        <div>
          <p class="title-n">현장약도</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />
        </div>
        <div>
          <p class="title-n">현장사진</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />
        </div>
      </div>

      <file-upload-module v-model="form.fileList" />
    </vx-card>
  </div>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import DateSelector from "@/components/selector/DateSelector";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        manager_name: "", // 관리감독자
        deposit_amount: "", // 계약금액
        address: "", //주소
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 완료
        phone: "", // 대표번호
        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진

        meta: {
          newClassification: "",
        }, // 부가 정보

        facility_category_id: "",
        safety_manager_name: "",
        start_work_at: "",
        be_completed_at: "",
        safety_grade: "",
        format: "",
        scale1: "",
        scale2: "",
        scale3: "",
        contract_code: "",

        fileList: [],
      },
      companyList: [],
      userList: [],
      joinUsers: [],
      cat1: "",
      cat2: "",
      cat3: "",
      cat4: "",
      newcat4: "",
      cat1List: [],
      cat2List: [],
      cat3List: [],
      cat4List: [],
    };
  },
  computed: {
    fieldId() {
      return this.$route.params.fieldId;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});

    const _cat1List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat1);
    this.cat1List = this.setCatOther(_cat1List);

    if (this.fieldId) {
      await this.loadField();
    }
  },
  validations: {
    form: {
      field_name: { required },
      facility_category_id: { required },
    },
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.field_name.required) {
          alert("시설명을 입력하세요.");
          return false;
        }

        if (!this.$v.form.facility_category_id.required) {
          if (!this.cat1) {
            alert("구분을 선택하세요.");
          } else if (!this.cat2) {
            alert("종류를 선택하세요.");
          } else if (!this.cat3) {
            alert("세분류를 선택하세요.");
          } else if (!this.newcat4) {
            alert("종별을 선택하세요.");
          }
          return false;
        }
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;
      this.joinUsers = info.users;

      let meta = JSON.parse(info.meta);
      if (typeof meta === "string") {
        meta = { newClassification: "" };
      }
      this.form = { ...info, meta };
      console.log(this.form);

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.facility_category) {
        this.cat1 = this.form.facility_category.cat1;
        this.cat2 = this.form.facility_category.cat2;
        this.cat3 = this.form.facility_category.cat3;
        this.cat4 = this.form.facility_category.id;
        this.newcat4 = this.form.meta.newClassification;
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },
    handleSearch(/*searching*/) {},
    handleSort(/*key, active*/) {},
    async onChangeCat1(data) {
      if (data) {
        const _temp_cat = this.form.facility_category && this.form.facility_category.cat1;
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        const _cat2List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat2);
        this.cat2List = this.setCatOther(_cat2List);

        // 문서를 불러왔을 경우, 기존의 값과 다르면 초기화
        if (data != _temp_cat) {
          this.cat2 = "";
          this.cat3 = "";
          this.cat4 = "";
          this.newcat4 = "";
          this.form.facility_category_id = "";
        }
      }
    },
    async onChangeCat2(data) {
      if (data) {
        const _temp_cat = this.form.facility_category && this.form.facility_category.cat2;
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.cat1, cat2: data });
        const _cat3List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat3);
        this.cat3List = this.setCatOther(_cat3List);

        // 문서를 불러왔을 경우, 기존의 값과 다르면 초기화
        if (data != _temp_cat) {
          this.cat3 = "";
          this.cat4 = "";
          this.newcat4 = "";
          this.form.facility_category_id = "";
        }
      } else {
        this.cat3List = [];
        this.cat4List = [];
      }
    },
    async onChangeCat3(data) {
      if (data) {
        const _temp_cat = this.form.facility_category && this.form.facility_category.cat3;
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.cat1, cat2: this.cat2, cat3: data });

        this.cat4List = this.$store.state.project.fieldFacilityCategoryOptions;
        console.log("fieldFacilityCategoryOptions", this.cat4List);
        // 문서를 불러왔을 경우, 기존의 값과 다르면 초기화
        if (data != _temp_cat) {
          this.cat4 = "";
          this.newcat4 = "";
          this.form.facility_category_id = "";
        }
        if (this.cat4List.length === 1 && this.cat4List[0].classification === "") {
          this.form.facility_category_id = this.cat4List[0].id;
          this.cat4 = "";
          this.newcat4 = "";
        }
      } else {
        this.cat4List = [];
      }
    },
    onChangeCat4(data) {
      this.form.facility_category_id = this.cat4List[0].id;
      this.form.meta.newClassification = this.newcat4;
    },
    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },
    onClickSave() {
      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      this.$emit("save", this.form);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
